import {SpinnerJSX} from "../../../../ticketsystem/modules/components/Spinner";
import React from "react";
import {TicketActivityRecord, WorkLogEntry} from "../../../API/request/ticket.interface";
import {IntlMessageValue, UniButton, UniCol, UniForm, UniRow} from "../../../../../@WUM/core/Elements";
import {ApiRoot} from "../../../../../@WUM/core/RestFullApi/api";
import {ToastFn} from "../../../../worktimetracking/Pages/components/save/SubmitHandler";

interface TicketTimeTrackingProps {
    id?: string
    Store: any
    response?: WorkLogEntry[] | boolean | undefined,
    setReload: React.Dispatch<React.SetStateAction<boolean>>
    reload: boolean
    recordId?: string
    setRecordId?: React.Dispatch<React.SetStateAction<string>>
    showToast: ToastFn;
    activityRecord?: TicketActivityRecord[] | boolean | undefined,
}

export const TicketTimeTracking = (props: TicketTimeTrackingProps): JSX.Element => {

    const {id, Store, setReload, reload, recordId, response, setRecordId, showToast, activityRecord} = props

    const [billable, setBillable] = React.useState(false);
    const [publicNote, setPublicNote] = React.useState(true);
    const [validated, setValidated] = React.useState(false);

    const selectedRecord: WorkLogEntry | undefined = React.useMemo((): WorkLogEntry | undefined => {
        if (!Array.isArray(response)) {
            return undefined;
        }

        return response.find((entry: WorkLogEntry): boolean => {
            return entry.id + "" === recordId;
        });
    }, [response, recordId]);

    const activityNoteContent: string = React.useMemo((): string => {
        if (!recordId || !Array.isArray(activityRecord)) {
            return '';
        }

        return activityRecord[0]?.content ?? '';
    }, [activityRecord, recordId]);

    const activityNoteId: string = React.useMemo((): string => {
        if (!Array.isArray(activityRecord)) {
            return '';
        }

        return activityRecord[0]?.id ?? '';
    }, [activityRecord]);

    React.useEffect(() => {
        if (!selectedRecord) {
            setBillable(false);
            return;
        }

        setBillable(selectedRecord.billable);
    }, [selectedRecord]);


    if (id === undefined ) {
        return <SpinnerJSX messageId={'common.loading'}/>
    }

    const send = (e: any) => {
        e.preventDefault()
        setValidated(true)
        let data = e.currentTarget

        if (!(data as HTMLFormElement).checkValidity()) {
            e.stopPropagation();
            return;
        }

        const formdata = new FormData(data)


        const raw = JSON.stringify({
            ...(recordId ? { id: recordId } : {}),
            ticketId: id,
            employeeId: Store.user.id,
            workAt: formdata.get('workAt'),
            startAt: formdata.get('startAt'),
            stopAt: formdata.get('stopAt'),
            billable: billable,
        })

        let requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization:
                    'Bearer ' +
                    JSON.parse(localStorage.getItem('token') as string)
            },
            body: raw
        }
        const form = e.currentTarget;

        fetch(ApiRoot() + `ticket/yoptimize/record/${id}/`, requestOptions)
            .then((response: Response) => response.json())
            .then((recordResponse: { msg: string; id: string }) => {
                const note = JSON.stringify({
                    ...(activityNoteId ? { id: activityNoteId } : {}),
                    typeChildId: recordResponse.id,
                    ticketId: id,
                    content: formdata.get("note"),
                    public: publicNote
                });

                const requestNote = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization:
                            "Bearer " +
                            JSON.parse(localStorage.getItem("token") as string),
                    },
                    body: note,
                };

                return fetch(ApiRoot() + `ticket/yoptimize/note/save/2/`, requestNote);
            })
            .then(() => {
                form.reset();
                setValidated?.(false);

                setReload(!reload);
                setBillable(false);
                setRecordId?.("");

                showToast({
                    func: "showToast",
                    type: "toast",
                    settings: ["variant", "success"],
                    content: "erfolg",
                    user: Store.user.id,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }



    return (
        <>
            <UniForm validated={validated} Submit={(e) => send(e)} key={recordId ?? 'new'}>
                <UniForm.InputGroup>
                    <UniForm.InputGroupText text={IntlMessageValue("","common.date",Store)}/>
                    <UniForm.FormControl required name={"workAt"} type={"date"}     defaultValue={selectedRecord?.workAt ?? ''}/>
                </UniForm.InputGroup>
                <UniForm.InputGroup>
                    <UniForm.InputGroupText text={IntlMessageValue("","ticket.start",Store)}/>
                    <UniForm.FormControl required name={"startAt"} type={"time"} defaultValue={selectedRecord?.startAt ?? ''}/>
                </UniForm.InputGroup>
                <UniForm.InputGroup>
                    <UniForm.InputGroupText text={IntlMessageValue("","ticket.end",Store)}/>
                    <UniForm.FormControl required name={"stopAt"} type={"time"} defaultValue={selectedRecord?.stopAt ?? ''}/>
                </UniForm.InputGroup>
                <UniForm.Checks name={"billable"} label={IntlMessageValue("","ticket.billable",Store)} type={"checkbox"} checked={billable}
                                onChange={(e) => setBillable((e.currentTarget as HTMLInputElement).checked)}/>
                <hr />
                <UniForm.FormGroup>
                    <UniForm.Label text={IntlMessageValue("","ticket.activity.report",Store)}/>
                    <UniForm.FormControl required name={"note"} type={"textarea"} as="textarea" rows={3} defaultValue={activityNoteContent ?? ''}
                    />
                </UniForm.FormGroup>
                <UniForm.Checks name={"public"} label={IntlMessageValue("","ticket.public",Store)} type={"checkbox"} checked={publicNote}
                                onChange={(e) => setPublicNote((e.currentTarget as HTMLInputElement).checked)}/>

                <UniRow>
                    <UniCol>
                        <UniButton
                            type={"button"}
                            onClick={(e) => {
                                const form = (e.currentTarget as HTMLButtonElement).closest("form");
                                form?.reset();

                                setBillable(false);
                                setRecordId?.("");
                                setValidated?.(false);
                            }}
                            variant={"outline-secondary"}
                        >
                            {IntlMessageValue("","ticket.reset",Store)}
                        </UniButton>
                    </UniCol>
                    <UniCol>
                        <UniButton type={"submit"} children={IntlMessageValue("","common.submit",Store)} variant={"success"}/>
                    </UniCol>
                </UniRow>
            </UniForm>
        </>
    )
}